import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VuePaginate from 'vue-paginate'

Vue.use(Vuex)
Vue.use(VuePaginate)
Vue.component('pagination', require('laravel-vue-pagination'))


export default new Vuex.Store({
  state: {
    investigadores:{
      current_page: 1,
      data: []
  },
    areas: [],
    organizaciones: [],
    nombre: 'José Santillán'
  },
  mutations: {
    globalRequest(){
      this.state.investigadores
      this.state.areas
      this.state.organizaciones
    },
    requestOrg(accionSol){
      this.state.organizaciones = accionSol
    }
	},
  actions: {
    listarInvestigadores({commit, page = 1}){
      let urlInv = `https://acceso-seicti.cocyted.mx/api/investigador?page=${page}`;
      axios.get(urlInv).then(response => {this.state.investigadores = response.data});
      commit('globalRequest')
      console.log("Investigadores " + this.state.investigadores.data)
    },
    traerAreas({commit}){
      let urlAreas = 'https://acceso-seicti.cocyted.mx/api/areas';
      // let urlAreas = 'https://staging.secti.mx/api/areas';
      axios.get(urlAreas).then(response => {this.state.areas = response.data.data});
      commit('globalRequest')
    },
    listarOrg({commit}){
      let urlOrg = 'https://acceso-seicti.cocyted.mx/api/organizaciones';
      // let urlOrg = 'https://staging.secti.mx/api/organizaciones';
      axios.get(urlOrg).then(response => {this.state.organizaciones = response.data.data});
      commit('requestOrg')
    },
  }
})
